export enum NOTIFY_ACTION {
    SHOW,
    HIDE,
    SET_NOTIFY_COUNT,
    SET_LOADING,
    SET_NOTIFICATIONS,
    SET_FILTER,
    SET_NOTIFY_READ,
    PUSH_TO_NOTIFICATIONS,
    MAP_JOB_INVITATION_NOTIFICATIONS,
    SET_READ_JOB_INVITATION
}

export enum FILTER_TYPE {
    ALL,
    UNREAD,
    READ
}
